import { get, post, put } from './apiService';

const tournamentService = {
  getTournaments: async () => {
    try {
      return await get('admin/gettournament', { withCredentials: false });
    } catch (err) {
      throw new Error(err.message || 'Failed to fetch tournaments');
    }
  },
  getTournament: async (id) => {
    try {
      return await get(`admin/getTournament/${id}`, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to fetch tournament');
    }
  },
  getBracket: async (id) => {
    try {
      return await get(`admin/${id}/bracket`, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to fetch bracket');
    }
  },
  createTournament: async (data) => {
    try {
      return await post('admin/createtournament', data, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to create tournament');
    }
  },
  updateTournament: async (data) => {
    try {
      return await put('admin/updatetournament', data, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to update tournament');
    }
  },
  startNextRound: async (id) => {
    try {
      return await post(`admin/startNextRound/${id}`, {}, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to start next round');
    }
  },
  startTournament: async (id) => {
    try {
      return await post(`admin/startTournament/${id}`, {}, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to start tournament');
    }
  },
  endTournament: async (id, winnerTeamId) => {
    try {
      return await post(`admin/endTournament/${id}`, { winnerTeamId }, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to end tournament');
    }
  },
  recordMatchResult: async (matchId, winnerTeamId) => {
    try {
      return await post(`admin/matches/${matchId}/record?winnerTeamId=${winnerTeamId}`, {}, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to record match result');
    }
  },
};

export default tournamentService;
